module.exports = __webpack_public_path__ + "static/media/bitpay.84a74ee0.png";